import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './TableCellDomainType.css';
import Dropdown from '../../../../../components/molecules/Dropdown';
import { DOMAIN_TYPE_OPTIONS } from '../consts';

const TableCellDomainType = props => {
    const { value, className, tdClassName, rowIndex, row, onChange } = props;
    const { isCreatingDomain, isBrandedDomain } = row;

    return (
        <td className={classNames(tdClassName, isCreatingDomain ? css.backgroundCreate : '')}>
            {!isCreatingDomain || rowIndex > 0 ? (
                <div className={css.labelContainer}>{value}</div>
            ) : (
                <div className={className}>
                    <Dropdown
                        onSelection={onChange}
                        selected={isBrandedDomain ? DOMAIN_TYPE_OPTIONS[1] : DOMAIN_TYPE_OPTIONS[0]}
                        items={DOMAIN_TYPE_OPTIONS}
                    />
                </div>
            )}
        </td>
    );
};

TableCellDomainType.propTypes = {
    value: PropTypes.string,
    type: PropTypes.string,
    row: PropTypes.object,
    className: PropTypes.string,
    onChange: PropTypes.func,
    tdClassName: PropTypes.string,
    rowIndex: PropTypes.number,
    error: PropTypes.string,
};

export default TableCellDomainType;
